import api from "@/api.js";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    overallPoints: [],
    overallPointsLoading: false,
    overallMedals: [],
    overallMedalsLoading: false,
    current: [],
    currentLoading: false,
    currentEventBrackets: null,
    currentEventBracketsLoading: false,
    competitions: [],
    competitionsLoading: false,
    athleteAndAssociationList: [],
    athleteAndAssociationListLoading: false,
  },
  mutations: {
    setOverallPoints(state, payload) {
      state.overallPoints = payload;
    },
    setOverallPointsLoading(state, payload) {
      state.overallPointsLoading = payload;
    },
    setOverallMedals(state, payload) {
      state.overallMedals = payload;
    },
    setOverallMedalsLoading(state, payload) {
      state.overallMedalsLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setCurrentEventBrackets(state, payload) {
      state.currentEventBrackets = payload;
    },
    setCurrentEventBracketsLoading(state, payload) {
      state.currentEventBracketsLoading = payload;
    },
    setCompetitions(state, payload) {
      state.competitions = payload;
    },
    setCompetitionsLoading(state, payload) {
      state.competitionsLoading = payload;
    },

    setAthleteAndAssociationList(state, payload) {
      state.athleteAndAssociationList = payload;
    },
    setAthleteAndAssociationListLoading(state, payload) {
      state.athleteAndAssociationListLoading = payload;
    }
  },
  actions: {
    async overallPoints({ commit }, filter) {
      commit("setOverallPointsLoading", true);
      let response = await api.get("liveResults/overallPoints", {
        params: filter
      });
      commit("setOverallPoints", response.data);
      commit("setOverallPointsLoading", false);
    },
    async overallMedals({ commit }, filter) {
      commit("setOverallMedalsLoading", true);
      let response = await api.get("liveResults/overallMedals", {
        params: filter
      });
      commit("setOverallMedals", response.data);
      commit("setOverallMedalsLoading", false);
    },
    async eventBrackets({ commit }, filter) {
      commit("setCurrentEventBracketsLoading", true);
      let response = await api.get("liveResults/events/brackets", {
        params: filter
      });
      commit("setCurrentEventBrackets", response.data);
      commit("setCurrentEventBracketsLoading", false);
    },
    async loadAllCompetitions({ commit }) {
      commit("setCompetitionsLoading", true);
      let response = await api.get("liveResults/competitions");
      commit("setCompetitions", response.data);
      commit("setCompetitionsLoading", false);
    },
    async loadAllAthleteAndAssociations({ commit }, id) {
      commit("setAthleteAndAssociationListLoading", true);
      let response = await api.get("liveResults/athletesAndAssociationsList", {
        params: {
          competitions_id: id
        }
      });
      commit("setAthleteAndAssociationList", response.data);
      commit("setAthleteAndAssociationListLoading", false);
    }
  },
  getters: {
    overallPoints(state) {
      return state.overallPoints.sort((a, b) => {
        return b.points - a.points;
      });
    },
    overallPointsLoading(state) {
      return state.overallPointsLoading;
    },
    overallMedals(state) {
      return state.overallMedals.sort((a, b) => {
        return b.medals - a.medals;
      });
    },
    overallMedalsLoading(state) {
      return state.overallMedalsLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    currentEventBrackets(state) {
      let event = state.currentEventBrackets;
      if (event) {
        let brackets = state.currentEventBrackets.brackets;
        event.brackets = brackets.reverse();
      }

      return event;
    },
    currentEventBracketsLoading(state) {
      return state.currentEventBracketsLoading;
    },
    competitions(state) {
      let today = moment();
      return state.competitions.sort((a, b) => {
        const a_end_date = a.end_date ? moment(a.end_date) : moment(a.start_date);
        const b_end_date = b.end_date ? moment(b.end_date) : moment(b.start_date);

        // If A is finished and B is not, B goes first
        if (a_end_date < today && b_end_date > today) {
          return 1;
        }

        // If B is finished and A is not, A goes first
        if (b_end_date < today && a_end_date > today) {
          return -1;
        }

        // If both are finished, Order opposite
        if (a_end_date < today && b_end_date < today) {
          return moment(a.start_date) > moment(b.start_date) ? -1 : 1;
        }

        if (moment(a.start_date) > moment(b.start_date)) {
          return 1;
        }

        if (moment(b.start_date) > moment(a.start_date)) {
          return -1;
        }

        // If dates are not set
        if (!a.start_date && b.start_date) {
          return 1;
        }

        if (a.start_date && !b.start_date) {
          return -1;
        }

        return 0;
      });
    },
    competitionsLoading(state) {
      return state.competitionsLoading;
    },
    athleteAndAssociationList(state) {
      return state.athleteAndAssociationList;

    },
    athleteAndAssociationListLoading(state) {
      return state.athleteAndAssociationListLoading;
    },
    eventResultByTimesDict(state) {

      if (!state.currentEventBrackets || state.currentEventBrackets.brackets.length != 2) {
        return null;
      }

      let times = {};


      for (let race of state.currentEventBrackets.brackets[1].races) {
        for (let lane of race.lanes) {
          if (lane.omegaResults) {
            times[lane.participant_id] = lane.omegaResults
          }
        }
      }


      return times
    }
  }
};
